// Feature flags
export enum FeatureFlags {
  SHOW_PERFORMANCE = 'show-performance-page',
}
